module.exports = __webpack_public_path__ + "static/media/0322_IMG_EN_CUISINE.c4311ada.webp";